import "./modal.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import ColorDot from "../interface/ColorDot";
import Icon from "../interface/Icon";
import ModalMasterList from "./ModalMasterList";
import ModalMasterListItem from "./ModalMasterListItem";

const MODAL_MASTER_LIST_VIEW_ID = "MODAL_MASTER_LIST_VIEW_ID";
const MODAL_MASTER_LIST_VIEW_FOOTER_ID = "MODAL_MASTER_LIST_VIEW_FOOTER_ID";

const isIos = preprocessorQuery.isIos();

class ModalMasterView extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.onAddClick = this.onAddClick.bind(this);
    this.itemRenderer = this.itemRenderer.bind(this);
  }

  onAddClick() {
    const index = this.props.items.findIndex(i => i.value === this.props.selectedItem);
    this.props.onAddClick(index);
  }

  itemRenderer(item, index, useDragHandle, width, slideUp, slideDown, canDrag, disabled, ref) {
    return (
      <ModalMasterListItem
        disabled={disabled}
        forwardedRef={ref}
        key={item.value}
        text={item.label}
        index={index}
        isSelected={item.value === this.props.selectedItem}
        width={width}
        leftElements={
          item.icon ? (
            <Icon icon={item.icon} color={item.color ? item.color : "mono"} />
          ) : item.color ? (
            <ColorDot color={item.color} />
          ) : null
        }
        rightElements={<Icon icon="rightArrow" color="mono" />}
        onClick={!disabled ? this.props.onItemSelect : null}
        clickContext={item.value}
        viewId={MODAL_MASTER_LIST_VIEW_ID}
        useDragHandle={useDragHandle}
        slideUp={slideUp}
        slideDown={slideDown}
        canDrag={canDrag && !disabled}
        className={item.className}
      />
    );
  }

  render() {
    const { items } = this.props;

    // Get the selected item so we can decide whether to show the delete button
    // TODO: Show a reset button instead if it cannot be deleted.
    const selectedItemIndex = items.findIndex(i => i.value === this.props.selectedItem);
    const selectedItem = items[selectedItemIndex];
    const onItemClick = newIndex => this.props.onItemSelect(items.find((item, index) => index === newIndex).value);

    const footer = isIos ? (
      this.props.onAddClick ? (
        <div className="modalMasterList iOSAddList">
          <div className="listView">
            <ModalMasterListItem
              text="Add New"
              index={0}
              isSelected={false}
              leftElements={null}
              rightElements={<Icon icon="rightArrow" color="mono" />}
              onClick={this.onAddClick}
              viewId={MODAL_MASTER_LIST_VIEW_FOOTER_ID}
              canDrag={false}
            />
          </div>
        </div>
      ) : null
    ) : (
      <div className="modalMasterFooter">
        {this.props.onAddClick ? (
          <FormButton label="Add" disabled={this.props.disabled} onClick={this.onAddClick} />
        ) : null}
        {selectedItem && selectedItem.canDelete && this.props.onDeleteClick ? (
          <FormButton
            destructive={true}
            label="Delete"
            disabled={this.props.disabled}
            onClick={this.props.onDeleteClick}
          />
        ) : null}
      </div>
    );

    return (
      <div className="modalMaster">
        <ModalMasterList
          disabled={this.props.disabled}
          viewId={MODAL_MASTER_LIST_VIEW_ID}
          allowDrag={this.props.allowDrag && !this.props.disabled}
          lockTopItemForDrag={this.props.lockTopItemForDrag}
          lockBottomItemForDrag={this.props.lockBottomItemForDrag}
          onMoveItemAtIndex={this.props.onMoveItemAtIndex}
          selectedItemIndex={selectedItemIndex}
          onItemClick={onItemClick}
          items={items}
          itemRenderer={this.itemRenderer}
        />
        {footer}
      </div>
    );
  }
}

ModalMasterView.propTypes = {
  disabled: PropTypes.bool,
  items: PropTypeShapes.listOptionArray.isRequired,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onItemSelect: PropTypes.func.isRequired,
  onAddClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  // Dragging to re-order items
  allowDrag: PropTypes.bool,
  lockTopItemForDrag: PropTypes.bool,
  lockBottomItemForDrag: PropTypes.bool,
  onMoveItemAtIndex: PropTypes.func
};

export default ModalMasterView;
